import React from "react";
import {
  DOC_CAPTURE_FILE_TYPES,
  DOC_CAPTURE_DEFAULT_FILE_TYPES,
} from "../../const/doc-capture-const";

/**
 * The file types a document capture step accepts, as toggle chips.
 *
 * Shared by the canvas's doc capture settings and the playbook's DOCUMENT ASK
 * step, so both editors offer the same list. An unset value shows the defaults;
 * an empty list is saved as-is and the runtime falls back to its full list.
 */
export function toggleFileType(current, fileType) {
  const selected = current || DOC_CAPTURE_DEFAULT_FILE_TYPES;
  return selected.includes(fileType)
    ? selected.filter(type => type !== fileType)
    : [...selected, fileType];
}

export default function AllowedFileTypes({ value, onChange, showHeader = true }) {
  const selectedTypes = value || DOC_CAPTURE_DEFAULT_FILE_TYPES;

  return (
    <div>
      {showHeader && (
        <>
          <label className="block text-sm font-medium text-gray-900">
            Allowed file types
          </label>
          <span className="text-sm text-gray-500">
            The uploader accepts only these. Clearing all of them falls back to the full list.
          </span>
        </>
      )}
      <div className={`flex flex-wrap gap-2 ${showHeader ? "pt-3" : ""}`}>
        {DOC_CAPTURE_FILE_TYPES.map(fileType => {
          const selected = selectedTypes.includes(fileType);
          return (
            <button
              key={fileType}
              type="button"
              aria-pressed={selected}
              onClick={() => onChange(toggleFileType(value, fileType))}
              className={`px-3 py-1 text-sm rounded-full border transition-colors ${
                selected
                  ? "bg-blue-600 border-blue-600 text-fixed-white"
                  : "bg-white border-gray-300 text-gray-600 hover:border-gray-400"
              }`}
            >
              {fileType}
            </button>
          );
        })}
      </div>
    </div>
  );
}
